/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class AVSCode extends RiskFactor {
    icon = 'map-marker';

    label = '<span class="has-tooltip has-tooltip-help" data-tooltip="Address Verification System">AVS</span> Code';

    static getCondition({avsResponse}) {
        return !!avsResponse && avsResponse.code !== null;
    }

    parse({avsResponse}) {
        this.avsResponse = avsResponse;
    }

    getResult() {
        return this.avsResponse.code;
    }
}
